<template>
    <div>
        <!-- #region Generic-->
        <AlertModal
            :modalId="alertId"
            :controller="controller.alertModal"
            v-if="controller.alertModal != null"
        ></AlertModal>
        <CancelModal
            :modalId="cancelId"
            :controller="controller.cancelModal"
            v-if="controller.cancelModal != null"
        ></CancelModal>
        <LoadingModal
            :modalId="loadingId"
            :controller="controller.loadingModal"
            v-if="controller.loadingModal != null"
        ></LoadingModal>
        <ConfirmModal
            :modalId="confirmId"
            :controller="controller.confirmModal"
            v-if="controller.confirmModal != null"
        ></ConfirmModal>
        <!-- #endregion Generic-->

        <!-- #region Authen-->
        <OtpModal
            :modalId="otpId"
            :controller="controller.otpModal"
            v-if="controller.otpModal != null"
        >
        </OtpModal>
        <!-- #endregion Authen-->

        <!-- #region Redeem-->
        <ConfirmRedeemModal
            :modalId="confirmRedeemId"
            :controller="controller.confirmRedeemModal"
            v-if="controller.confirmRedeemModal != null"
        >
        </ConfirmRedeemModal>
        <SerialModal
            :modalId="serialId"
            :controller="controller.serialModal"
            v-if="controller.serialModal != null"
        >
        </SerialModal>
        <ShippingAddressModal
            :modalId="shippingAddressId"
            :controller="controller.shippingAddressModal"
            v-if="controller.shippingAddressModal != null"
        ></ShippingAddressModal>
        <QrModal
            :modalId="QrId"
            :controller="controller.QrModal"
            v-if="controller.shippingAddressModal != null"
        ></QrModal>
        <!-- #endregion Redeem-->

        <!-- #region Address -->
        <AddAddressModal
            :modalId="addAddressId"
            :controller="controller.addAddressModal"
            v-if="controller.addAddressModal != null"
        ></AddAddressModal>
        <EditAddressModal
            :modalId="editAddressId"
            :controller="controller.editAddressModal"
            v-if="controller.editAddressModal != null"
        ></EditAddressModal>
        <ListAddressModal
            :modalId="listAddressId"
            :controller="controller.listAddressModal"
            v-if="controller.listAddressModal != null"
        ></ListAddressModal>
        <AddTaxAddressModal
            :modalId="addTaxAddressId"
            :controller="controller.addTaxAddressModal"
            v-if="controller.addTaxAddressModal != null"
        ></AddTaxAddressModal>
        <EditTaxAddressModal
            :modalId="editTaxAddressId"
            :controller="controller.editTaxAddressModal"
            v-if="controller.editTaxAddressModal != null"
        ></EditTaxAddressModal>
        <ListTaxAddressModal
            :modalId="listTaxAddressId"
            :controller="controller.listTaxAddressModal"
            v-if="controller.listTaxAddressModal != null"
        ></ListTaxAddressModal>
        <!-- #endregion Address -->
    </div>
</template>
<script>
//Generic modal
import AlertModal from "./Generic/Modal/AlertModal.vue";
import LoadingModal from "./Generic/Modal/LoadingModal.vue";
import ConfirmModal from "./Generic/Modal/ConfirmModal.vue";
import CancelModal from "./Generic/Modal/CancelModal.vue";
//Authen modal
import OtpModal from "./Authen/OTP/OtpModal";
//Redeem modal
import QrModal from "./Redeem/Qr/QrModal.vue";
import ConfirmRedeemModal from "./Redeem/ConfirmRedeem/ConfirmRedeemModal.vue";
import SerialModal from "./Redeem/Serial/SerialModal.vue";
import ShippingAddressModal from "./Redeem/ShippingAddress/ShippingAddressModal.vue";
//Address modal
import AddAddressModal from "./Address/Add/AddAddressModal.vue";
import EditAddressModal from "./Address/Edit/EditAddressModal.vue";
import ListAddressModal from "./Address/List/ListAddressModal.vue";
import AddTaxAddressModal from "./Address/Add/AddTaxAddressModal.vue";
import EditTaxAddressModal from "./Address/Edit/EditTaxAddressModal.vue";
import ListTaxAddressModal from "./Address/List/ListTaxAddressModal.vue";

/**
 * @property {ModalController} controller (required) /components/Modal/Controller/ModalController.js
 */
export default {
    name: "ModalMaster",
    props: {
        controller: Object
    },
    components: {
        //generic
        AlertModal,
        CancelModal,
        LoadingModal,
        ConfirmModal,
        //Authen
        OtpModal,
        //Redeem
        ConfirmRedeemModal,
        SerialModal,
        ShippingAddressModal,
        QrModal,
        //Address
        AddAddressModal,
        EditAddressModal,
        ListAddressModal,
        AddTaxAddressModal,
        EditTaxAddressModal,
        ListTaxAddressModal
    },
    data: function() {
        return {
            randomNum: Math.floor(Math.random() * 100000) + "",
            //generic
            alertId: "",
            cancelId: "",
            loadingId: "",
            confirmId: "",
            //authen
            otpId: "",
            //redeem
            confirmRedeemId: "",
            drawDeliveryId: "",
            serialId: "",
            shippingAddressId: "",
            QrId: "",
            //address
            addAddressId: "",
            editAddressId: "",
            listAddressId: "",
            addTaxAddressId: "",
            editTaxAddressId: "",
            listTaxAddressId: ""
        };
    },
    created: function() {
        //generic
        this.alertId = "alert_modal_" + this.randomNum;
        this.loadingId = "loading_modal_" + this.randomNum;
        this.confirmId = "confirm_modal_" + this.randomNum;
        this.cancelId = "cancel_modal_" + this.randomNum;
        //authen
        this.otpId = "otp_modal_" + this.randomNum;
        //redeem
        this.confirmRedeemId = "confirm_redeem_modal_" + this.randomNum;
        this.drawDeliveryId = "draw_delivery_modal_" + this.randomNum;
        this.serialId = "serial_modal_" + this.randomNum;
        this.shippingAddressId = "shipping_address_modal_" + this.randomNum;
        this.QrId = "qr_modal_" + this.randomNum;
        //address
        this.addAddressId = "add_address_modal_" + this.randomNum;
        this.editAddressId = "edit_address_modal_" + this.randomNum;
        this.listAddressId = "list_address_modal_" + this.randomNum;
        this.addTaxAddressId = "add_tax_address_modal_" + this.randomNum;
        this.editTaxAddressId = "edit_tax_address_modal_" + this.randomNum;
        this.listTaxAddressId = "list_tax_address_modal_" + this.randomNum;
    }
};
</script>
